import React from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  IconButton,
  ListItemText,
  makeStyles,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { gpColors } from "../../constants/colors";
import { useState } from "react";
import SideDrawer from "./Drawer";
import { useEffect } from "react";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import { getCookie } from "../../Functions";
import AddProductValMOdal from "./AddProductValMOdal";
import { Delete, DeleteForever } from "@material-ui/icons";
import { useNavigate } from "react-router-dom";
import { routes } from "../../constants/routes";
import api from "../Interceptors/axiosInstance";
import Cookies from "js-cookie";
const useStyles = makeStyles((theme) => ({
  roots: {
    display: "flex",
    height: "auto",
  },
  content: {
    backgroundColor: "#EAE4E8",
    flexGrow: 1,
    paddingTop: "84px",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    height: "100%",
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    paddingBottom: 20,
  },
  root: {
    padding: "30px",
    minHeight: "280px",
    marginTop: "20px",
  },
  fieldBox: {
    width: "48%",
    margin: 5,
    [theme.breakpoints.only("xs")]: {
      width: "100%",
      margin: "10px",
    },
    [theme.breakpoints.only("sm")]: {
      width: "100%",
      margin: "10px",
    },
  },
  textFieldStyle: {
    width: "100%",
    height: "40px",
  },
  selectFieldStyle: {
    width: "100%",
    height: "40px",
    [theme.breakpoints.only("xs")]: {
      width: "93%",
    },
    [theme.breakpoints.only("sm")]: {
      width: "96%",
    },
  },
  submitButton: {
    textTransform: "none",
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
    marginBottom: "12px",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
  },
  loaderContainer: {
    textAlign: "center",
    color: "#BE0A00",
    alignItems: "center",
    backgroundColor: "",
    display: "flex",
    justifyContent: "center",
    height: "30vh",
  },
  img: {
    height: "100%",
    width: "50%",
    [theme.breakpoints.only("sm")]: {
      width: "30%",
    },
  },
  imgBox: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "flex-start",
    //mobile view
    [theme.breakpoints.only("xs")]: {
      justifyContent: "center",
    },
    // ipad view
    [theme.breakpoints.only("sm")]: {
      justifyContent: "center",
    },
  },
  deleteButton: {
    color: "#f32013",
  },
}));

function EditProducts() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [userData, setUserData] = useState({});
  const [productCategoryList, setProductCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [addProductData, setAddProductData] = useState({
    gpa: "",
    product_category_id: "",
    brand_id: [],
    brand_no: [],
    application: "",
    image: "",
    brandDetails: [],
  });
  const [brandName, setBrandName] = useState([]);
  const [imgSizeError, setImgSizeError] = useState("");
  const [deleteImge, setDeleteImage] = useState(false);
  var part_no = JSON.parse(localStorage.getItem("part_no"));

  const [validationModal, setValidationModal] = useState(false);
  function openValidationModal() {
    setValidationModal(true);
  }
  function closeValidationModal() {
    setValidationModal(false);
  }

  const [alert, setAlert] = useState({
    alertStatus: false,
    alertMessage: "",
    alertColor: "",
  });

  // Alert box close
  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({
      ...alert,
      alertStatus: false,
      alertColor: "",
      alertMessage: "",
    });
  };
  // get part details
  const getPartDetails = async (userVal) => {
    setLoader(true);
    try {
      console.log("getPartDetaisl");
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/getPartNosData/${part_no.part_no}`,
      //   {
      //     method: "GET",
      //     headers: {
      //       Authorization: `Token ${userVal.loginInfo.data.jwt}`,
      //       // // "ngrok-skip-browser-warning": "true",
      //     },
      //   }
      // );
      const resp = await api.get(`/getPartNosData/${part_no.part_no}`);
      const data = await resp.data;

      getBrandList(userVal, data);
      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  //Getting brand List for form dropdown
  const getBrandList = async (userVal, data) => {
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/getBrandsList`,
      //   {
      //     method: "GET",
      //     headers: {
      //       "Access-Control-Allow-Origin": "*",
      //       Authorization: `Token ${userVal.loginInfo.data.jwt}`,
      //       // // "ngrok-skip-browser-warning": "true",
      //     },
      //   }
      // );
      const resp = await api.get(`/getBrandsList`);

      const data1 = await resp.data;
      setBrandList(data1);
      let bId = [];
      let b = [...addProductData.brandDetails];
      console.log(brandList);
      data[0].brand.split(",").forEach((item, index) => {
        let filterByBrand = data1.filter((i) => i.brand === item);
        bId.push(filterByBrand[0].id);
        setAddProductData({ ...addProductData, brand_id: bId });

        // set brand name, id and brandvalue only once and not override
        if (
          b.findIndex((element) => element.id === filterByBrand[0].id) === -1
        ) {
          b.push({
            id: filterByBrand[0].id,
            brandName: filterByBrand[0].brand,
            brandValue: data[0].brand_no.split(",")[index],
          });
        }
        // set data to addProductData then that display in the form
        setAddProductData({
          ...addProductData,
          gpa: data[0].part_no,
          product_category_id: data[0].product_category_id,
          application: data[0].application,
          image: data[0].image_name,
          brand_id: bId,
          brandDetails: b,
          brand_no: data[0].brand_no.split(","),
        });
        setBrandName(data[0].brand.split(","));
      });
    } catch (e) {
      console.log(e);
    }
  };

  //Getting product category list for form dropdown
  const getProductCategoryList = async (userVal) => {
    console.log("token", userVal);
    // fetch(`${process.env.REACT_APP_API_ENDPOINT}/getProductCategory`, {
    //   method: "GET",
    //   headers: {
    //     // // "ngrok-skip-browser-warning": "true",
    //     Authorization: `Token ${userVal.loginInfo.data.jwt}`,
    //   },
    // })
    //   .then((response) => response.json())
    //   .then((json) => setProductCategoryList(json));
    const resp = await api.get(`/getProductCategory`);
    const data = await resp.data;
    console.log("res: ", data);
    if (data) {
      setProductCategoryList(data);
    }
  };

  //Getting cookies
  // const getLoginInfoData = () => {
  //   const getValue = getCookie("guardPlus_user");
  //   if (getValue !== null) {
  //     const decryptedValue = CryptoAES.decrypt(getValue, "secretKey");
  //     const userVal = JSON.parse(decryptedValue.toString(CryptoENC));
  //     setUserData(userVal);
  //     getPartDetails(userVal);
  //     getProductCategoryList(userVal);
  //   }
  // };

  // const sessionUsername = Cookies.get("userName");
  const sessionUsername = sessionStorage.getItem("userName");

  const getLoginInfoData = () => {
    // setUserData({ username: sessionUsername });
    getPartDetails({ username: sessionUsername });
    getProductCategoryList({ username: sessionUsername });
  };
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    getLoginInfoData();
  }, []);

  function handleFormChange(e, para, position) {
    let value = e.target.value;
    let name = e.target.name;
    if (para === "brandList") {
      setBrandName(
        // On autofill we get a stringified value.
        typeof value === "string" ? value.split(",") : value
      );
      let bId = [];
      let b = [...addProductData.brandDetails];

      value.forEach((item, index) => {
        let filterByBrand = brandList.filter((i) => i.brand === item);
        bId.push(filterByBrand[0].id);
        setAddProductData({ ...addProductData, brand_id: bId });

        // set brand name, id and brandvalue only once and not override
        if (
          b.findIndex((element) => element.id === filterByBrand[0].id) === -1
        ) {
          b.push({
            id: filterByBrand[0].id,
            brandName: filterByBrand[0].brand,
            brandValue: "",
          });
        }
        setAddProductData({
          ...addProductData,
          brand_id: bId,
          brandDetails: b,
        });
      });

      // if checkbox is unchecked in that case also delete from brandDetails
      let finalBrandData = [];
      if (b.length > bId.length) {
        bId.forEach((item) => {
          finalBrandData.push(b.find((element) => element.id === item));
        });
        // if unchecked brand checkbox in that case there value also delete from brandno
        let a = [];
        finalBrandData.forEach((value, index) => {
          a.push(value.brandValue);
        });
        // setAddProductData({ ...addProductData, brand_no: a });
        setAddProductData({
          ...addProductData,
          brand_id: bId,
          brandDetails: finalBrandData,
          brand_no: a,
        });
      }
    } else if (para === "brandValue") {
      console.log(addProductData);
      let b = [...addProductData.brandDetails];
      b[position].brandValue = value;
      let a = [];
      b.forEach((value, index) => {
        a.push(value.brandValue);
      });
      setAddProductData({ ...addProductData, brandDetails: b, brand_no: a });
    } else if (para === "imageFile") {
      // image size not greater than 10MB
      let file = e.target.files[0];
      if (file.size > 10e6) {
        setImgSizeError("Please upload a file smaller than 10 MB.");
        setAddProductData({ ...addProductData, [name]: "" });
      } else {
        setImgSizeError("");
        setAddProductData({ ...addProductData, [name]: file.name });
      }
    } else {
      setAddProductData({ ...addProductData, [name]: value });
    }
  }
  console.log(addProductData);
  const checkValidation = async () => {
    console.log(addProductData);
    let result = true;

    //validations for form fields
    Object.keys(addProductData).forEach(function (key) {
      if (addProductData[key].length === 0) {
        result = false;
        openValidationModal();
      } else if (key === "brandDetails") {
        addProductData[key].forEach((item, index) => {
          if (item.brandValue.length === 0) {
            result = false;
            openValidationModal();
          }
        });
      }
    });

    // when all fields are filled then save data
    if (result) {
      submitForm();
    }
  };

  const submitForm = async () => {
    // // The FormData interface provides a way to construct a set of
    // // key/value pairs representing form fields and their values,
    // // which can be sent using the fetch()
    const formData = new FormData();
    // formData.append("gpa", `${addProductData.gpa}`);
    formData.append(
      "product_category_id",
      `${addProductData.product_category_id}`
    );
    formData.append("brand_id", addProductData.brand_id);
    formData.append("brand_no", addProductData.brand_no);
    formData.append("application", `${addProductData.application}`);

    console.log(formData);
    setBtnLoader(true);
    try {
      if (deleteImge === true) {
        const fileField = document.getElementById("file");
        console.log(fileField.files[0]);
        formData.append("image", fileField.files[0]);
        // const resp = await fetch(
        //   `${process.env.REACT_APP_API_ENDPOINT}/updatePartNosData/${part_no.part_no}`,
        //   {
        //     method: "POST",
        //     body: formData,
        //     headers: {
        //       // // "ngrok-skip-browser-warning": "true",
        //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
        //     },
        //   }
        // );
        const resp = await api.post(
          `/updatePartNosData/${part_no.part_no}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        const data = await resp.data;
        console.log(data);
        setBtnLoader(false);
        if (data.hasOwnProperty("message")) {
          setAlert({
            ...alert,
            alertStatus: true,
            alertColor: "red",
            alertMessage: "Something went wrong please try again.",
          });
        } else if (data.hasOwnProperty("result")) {
          if (data.result === "Success") {
            setAlert({
              ...alert,
              alertStatus: true,
              alertColor: "green",
              alertMessage: "Product details has been updated successfully!!",
            });
            // if data is successfully replace then go to add product page
            setTimeout(function () {
              navigate(routes.ADD_PRODUCTS);
            }, 1000);
          }
        }
      } else {
        console.log("without image");
        // const resp = await fetch(
        //   `${process.env.REACT_APP_API_ENDPOINT}/updatePartNos/${part_no.part_no}`,
        //   {
        //     method: "POST",
        //     body: formData,
        //     headers: {
        //       // // "ngrok-skip-browser-warning": "true",
        //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
        //     },
        //   }
        // );
        const resp = await api.post(
          `/updatePartNos/${part_no.part_no}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        const data = await resp.data;
        console.log(data);
        setBtnLoader(false);
        if (data.hasOwnProperty("message")) {
          setAlert({
            ...alert,
            alertStatus: true,
            alertColor: "red",
            alertMessage: "Something went wrong please try again.",
          });
        } else if (data.hasOwnProperty("result")) {
          if (data.result === "Success") {
            setAlert({
              ...alert,
              alertStatus: true,
              alertColor: "green",
              alertMessage: "Product details has been updated successfully!!",
            });
            // if data is successfully replace then go to add product page
            setTimeout(function () {
              navigate(routes.ADD_PRODUCTS);
            }, 1000);
          }
        }
      }
    } catch (e) {
      console.log(e);
      setBtnLoader(false);
    }
  };

  const handleDeleteImage = () => {
    setAddProductData({ ...addProductData, image: "" });
    setDeleteImage(true);
  };
  return (
    <div className={classes.roots}>
      <SideDrawer tabName="products"/>
      <main className={classes.content}>
        <div className={classes.title}>
          Edit Product - {part_no && part_no.part_no}
        </div>
        <Divider />

        <Card className={classes.root}>
          <CardContent>
            {loader && (
              <Box className={classes.loaderContainer}>
                <CircularProgress color="inherit" />
              </Box>
            )}
            {!loader && (
              <>
                <Box display="flex" flexWrap="wrap">
                  <Box className={classes.fieldBox}>
                    <Typography>
                      Product Category<label style={{ color: "red" }}>*</label>
                    </Typography>
                    <Select
                      className={classes.textFieldStyle}
                      variant="outlined"
                      size="small"
                      defaultValue=""
                      name="product_category_id"
                      value={addProductData.product_category_id}
                      onChange={(e) => handleFormChange(e)}
                      MenuProps={{
                        getContentAnchorEl: null,
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                      }}
                    >
                      {productCategoryList.map((item, index) => (
                        <MenuItem value={item.id} key={index}>
                          {item.product_category}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                  <Box className={classes.fieldBox}>
                    <Typography>
                      GPA#<label style={{ color: "red" }}>*</label>
                    </Typography>
                    <TextField
                      variant="outlined"
                      // fullWidth
                      size="small"
                      className={classes.textFieldStyle}
                      name="gpa"
                      value={addProductData.gpa}
                      onChange={(e) => handleFormChange(e)}
                      disabled //dont want to update GPA#
                      helperText={"You can't edit GPA#."}
                    />
                  </Box>
                  <Box width="100%">
                    <Box className={classes.fieldBox}>
                      <Typography>
                        Brand<label style={{ color: "red" }}>*</label>
                      </Typography>
                      <Select
                        className={classes.selectFieldStyle}
                        variant="outlined"
                        id="brand-checkbox"
                        multiple
                        value={brandName}
                        onChange={(e) => handleFormChange(e, "brandList")}
                        input={<OutlinedInput />}
                        renderValue={(selected) => selected.join(",")}
                        MenuProps={{
                          getContentAnchorEl: null,
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                        }}
                      >
                        {brandList.map((bData, bIndex) => (
                          <MenuItem key={bIndex} value={bData.brand}>
                            <Checkbox
                              checked={brandName.indexOf(bData.brand) > -1}
                              size="small"
                            />
                            <ListItemText primary={bData.brand} />
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    <Box display="flex" flexWrap="wrap">
                      {addProductData.brandDetails.length !== 0 &&
                        addProductData.brandDetails.map((value, position) => (
                          <Box className={classes.fieldBox} key={position}>
                            <Typography>
                              {value.brandName}
                              <label style={{ color: "red" }}>*</label>
                            </Typography>
                            <TextField
                              variant="outlined"
                              size="small"
                              className={classes.textFieldStyle}
                              onChange={(e) =>
                                handleFormChange(e, "brandValue", position)
                              }
                              value={value.brandValue}
                            />
                          </Box>
                        ))}
                    </Box>
                  </Box>
                  <Box className={classes.fieldBox}>
                    <Typography>
                      Application<label style={{ color: "red" }}>*</label>
                    </Typography>
                    <TextField
                      variant="outlined"
                      size="small"
                      className={classes.textFieldStyle}
                      name="application"
                      value={addProductData.application}
                      onChange={(e) => handleFormChange(e)}
                    />
                  </Box>
                  <Box className={classes.fieldBox}>
                    {deleteImge === true && (
                      <>
                        <Typography>
                          Upload Image<label style={{ color: "red" }}>*</label>
                        </Typography>
                        <input
                          type="file"
                          id="file"
                          style={{ paddingTop: "10px", paddingBottom: "10px" }}
                          name="image"
                          onChange={(e) => handleFormChange(e, "imageFile")}
                        />
                        <Box>
                          <Typography variant="caption" color="error">
                            {imgSizeError}
                          </Typography>
                        </Box>
                      </>
                    )}
                    {deleteImge === false && (
                      <Box className={classes.imgBox}>
                        <img
                          id="uploaded-img"
                          src={`${process.env.REACT_APP_IMAGE_URL}/${addProductData.image}`}
                          alt="Uploaded Image"
                          className={classes.img}
                          loading="lazy"
                        />
                        <Tooltip title="Remove image" arrow>
                          <span>
                            <IconButton
                              className={classes.deleteButton}
                              onClick={() => handleDeleteImage()}
                            >
                              <DeleteForever />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </Box>
                    )}
                  </Box>
                </Box>
                <Box display="flex" justifyContent="center" marginTop={2}>
                  <Button
                    type="submit"
                    className={classes.submitButton}
                    onClick={() => checkValidation()}
                  >
                    {btnLoader ? <CircularProgress size={25} /> : "SUBMIT"}
                  </Button>
                </Box>
              </>
            )}
          </CardContent>
        </Card>
        {/* <ProductDetails
          userData={userData}
          updateData={updateData}
          setUpdateData={setUpdateData}
        /> */}
      </main>

      {/* Validation modal and alert box for API results component */}
      <AddProductValMOdal
        validationModal={validationModal}
        closeValidationModal={closeValidationModal}
        handleAlertClose={handleAlertClose}
        alert={alert}
      />
    </div>
  );
}

export default EditProducts;
